import angular from 'angular';
import providersModule from './providers/shared-providers';
import componentsModule from './components/shared-components';
import SharedService from './shared.service';
import FiltersModule from './filters/filters';
import SharedController from './shared.controller';
import DirectivesModule from './directives/directives';

import pdfViewerModule from './components/pdf-viewer/pdf-viewer';

let sharedModule = angular.module('shared', [
  providersModule.name,
  FiltersModule.name,
  DirectivesModule.name,
  componentsModule.name,
  pdfViewerModule.name
])
  .controller('SharedController', SharedController)
  .service('SharedService', SharedService);

export default sharedModule;



/** WEBPACK FOOTER **
 ** C:/Bitnami/wampstack-7.1.31-0/apache2/htdocs/toning/B2C/www/components/shared/shared.js
 **/